import { Link } from "react-router-dom";
import { Linkedin, Mail, Phone, Globe } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t mt-20" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <img
              src="https://customer-assets.emergentagent.com/job_fundcollect-1/artifacts/z3sp2s14_logo-sen-cagnotte-1.png"
              alt="Sen Cagnotte"
              className="h-10 w-10 rounded-xl object-cover"
            />
            <span className="font-display font-bold text-lg">Sen Cagnotte</span>
          </div>
          <p className="text-sm text-muted-foreground max-w-md leading-relaxed">
            Plateforme premium de cagnottes en ligne, conçue pour le Sénégal et l'Afrique francophone.
            Collectez des fonds en toute confiance.
          </p>
        </div>

        <div>
          <h4 className="font-semibold mb-3 text-sm">Navigation</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/explore" className="hover:text-foreground transition">Explorer</Link></li>
            <li><Link to="/about" className="hover:text-foreground transition">À propos</Link></li>
            <li><Link to="/cagnotte/new" className="hover:text-foreground transition">Créer une cagnotte</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold mb-3 text-sm">Contact</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 shrink-0" /> <a href="mailto:contact@dkr-consulting.com" className="hover:text-foreground">contact@dkr-consulting.com</a></li>
            <li className="flex items-center gap-2"><Phone className="h-4 w-4 shrink-0" /> +221 77 831 20 02</li>
            <li className="flex items-center gap-2"><Globe className="h-4 w-4 shrink-0" /> <a href="https://www.dkr-consulting.com" target="_blank" rel="noreferrer" className="hover:text-foreground">dkr-consulting.com</a></li>
            <li className="flex items-center gap-2"><Linkedin className="h-4 w-4 shrink-0" /> <a href="https://www.linkedin.com/in/djiby-ndiaye-11a92534/" target="_blank" rel="noreferrer" className="hover:text-foreground">Djiby NDIAYE</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-xs text-muted-foreground flex flex-col sm:flex-row justify-between items-center gap-2">
          <span>© 2026 Sen Cagnotte — Conçu par Djiby NDIAYE · DKR Consulting</span>
          <span>Paiements sécurisés Wave & Orange Money</span>
        </div>
      </div>
    </footer>
  );
}
